/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddNoteInput = {|
  postId: string,
  note?: ?string,
|};
export type SimpleAddNoteMutationVariables = {|
  input: AddNoteInput
|};
export type SimpleAddNoteMutationResponse = {|
  +addNote: ?{|
    +noteEdge: ?{|
      +cursor: string,
      +node: ?{|
        +id: string,
        +note: string,
        +date_saved: string,
        +isNote: boolean,
      |},
    |}
  |}
|};
export type SimpleAddNoteMutation = {|
  variables: SimpleAddNoteMutationVariables,
  response: SimpleAddNoteMutationResponse,
|};
*/


/*
mutation SimpleAddNoteMutation(
  $input: AddNoteInput!
) {
  addNote(input: $input) {
    noteEdge {
      cursor
      node {
        id
        note
        date_saved
        isNote
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddNotePayload",
    "kind": "LinkedField",
    "name": "addNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteNodeEdge",
        "kind": "LinkedField",
        "name": "noteEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "note",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date_saved",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNote",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SimpleAddNoteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SimpleAddNoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6ec0de81fd52082e5695c8aca9c07435",
    "id": null,
    "metadata": {},
    "name": "SimpleAddNoteMutation",
    "operationKind": "mutation",
    "text": "mutation SimpleAddNoteMutation(\n  $input: AddNoteInput!\n) {\n  addNote(input: $input) {\n    noteEdge {\n      cursor\n      node {\n        id\n        note\n        date_saved\n        isNote\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0a8f2cbe16c557e403ce4da25930b9d2';

module.exports = node;
